import React from 'react'
import { cn } from '@/lib/utils'
import ImageIcon from '@/assets/builder/icon/ImageIcon'

interface OptionType {
    id: string
    text?: string
    thumbnailUrl?: string
    imageUrl?: string
    [key: string]: any
}

interface SingleSelectImageProps {
    questionId: string
    options: OptionType[]
    hideLabel?: boolean
    selectedOptionId?: string
}

const SingleSelectImage: React.FC<SingleSelectImageProps> = ({
    questionId,
    options,
    hideLabel = false,
    selectedOptionId,
}) => {
    return (
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 gap-4 mt-4 w-full ">
            {options.map((option: OptionType, idx: number) => (
                <div
                    key={option.id}
                    aria-pressed={selectedOptionId === option.id}
                    className={cn(
                        'relative flex flex-col rounded-lg p-3 transition-all w-full min-h-[120px] border transition-colors ',
                        selectedOptionId === option.id
                            ? 'bg-gray-100 border-gray-200'
                            : 'bg-white border-gray-200'
                    )}
                >
                    {!hideLabel && (
                        <span
                            className="mb-2 font-medium block w-full text-xs text-gray-700 text-left line-clamp-2"
                            title={option.text || `Response ${idx + 1}`}
                        >
                            {option.text || `Response ${idx + 1}`}
                        </span>
                    )}
                    <div
                        className={cn(
                            'flex items-center justify-center rounded-md overflow-hidden flex-1 w-full bg-transparent',
                            !option.imageUrl && 'bg-gray-100'
                        )}
                    >
                        {option.imageUrl ? (
                            <img
                                src={option.imageUrl}
                                alt={option.text || `Response ${idx + 1}`}
                                className="object-contain w-full h-full"
                            />
                        ) : (
                            <ImageIcon fill="#9CA3AF" />
                        )}
                    </div>
                </div>
            ))}
        </div>
    )
}

export default SingleSelectImage
